export const sanitize = (text: string): string => {
  return text.replace(/\s+/g, ' ').trim();
};
